import { useParams } from "react-router-dom";
import { ContractorProvider } from "../context";
import ContractorContent from "./ContractorContent";
import ContractorAlert from "./ContractorAlert";

const ContractorDirectory = () => {
  const { contractorId } = useParams();

  return contractorId ? (
    <ContractorProvider contractorId={contractorId}>
      <ContractorContent />
    </ContractorProvider>
  ) : (
    <ContractorAlert
      title="table.noData"
      message="contractors.noContractorId"
    />
  );
};

export default ContractorDirectory;
